"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/app/main.component.ts');
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
const material_1 = require("@angular/material");
const core_2 = require("@ngx-translate/core");
const app_service_1 = require("../commons/app.service");
const global_1 = require("../commons/global");
const _4d_mapper_1 = require("4d-mapper");
const main_service_1 = require("./main.service");
const forms_1 = require("@angular/forms");
const AppBaseComponent_1 = require("../commons/AppBaseComponent");
const map_service_1 = require("../commons/map.service");
const index_1 = require("rxjs/index");
const Constants_1 = require("../commons/Constants");
const upload_global_component_1 = require("../commons/dialogs/upload-global/upload-global.component");
const upload_to_project_component_1 = require("../commons/dialogs/upload-to-project/upload-to-project.component");
const setup_dialog_1 = require("../commons/dialogs/setup-dialog");
const acl_service_1 = require("../commons/acl/acl.service");
const plugin_manager_service_1 = require("../service/plugin-manager.service");
const stream_data_service_1 = require("../v2/commons/stream-data.service");
const file_data_service_1 = require("../v2/commons/file-data.service");
const sharable_component_1 = require("./sharable/sharable.component");
const plugins_1 = require("../commons/plugins/plugins");
const measurement_helper_service_1 = require("../service/measurement-helper.service");
const platform_browser_1 = require("@angular/platform-browser");
const loading_spinner_1 = require("../commons/ui/loading-spinner");
const application_events_service_1 = require("../xs/services/events/application-events.service");
const ui_manager_service_1 = require("../xs/services/ui/ui-manager.service");
const scene_controller_service_1 = require("../service/controllers/scene-controller.service");
const ng_snotify_1 = require("ng-snotify");
const map_viewer_service_1 = require("../service/map-viewer.service");
const await_class_1 = require("../xs/controllers/await.class");
const incoming_data_service_1 = require("../xs/services/data/incoming-data.service");
const _ = require('underscore');
const Cesium = window.Cesium;
// declare var fdm: any;
//var when = require('cesium/Source/ThirdParty/when');
// var lodash = require('lodash');
class MainComponent extends AppBaseComponent_1.AppBaseComponent {
    constructor(fourD, service, router, snackBar, dialog, incomingData, translate, cdref, mapService, cesiumMap, mainService, permissions, activatedRoute, applicationEvents, v2Stream, v2FileService, pluginManager, measureHelper, uiManager, sanitizer, sceneController, snotify) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.incomingData = incomingData;
        this.translate = translate;
        this.cdref = cdref;
        this.mapService = mapService;
        this.cesiumMap = cesiumMap;
        this.mainService = mainService;
        this.permissions = permissions;
        this.activatedRoute = activatedRoute;
        this.v2Stream = v2Stream;
        this.v2FileService = v2FileService;
        this.pluginManager = pluginManager;
        this.measureHelper = measureHelper;
        this.uiManager = uiManager;
        this.sanitizer = sanitizer;
        this.sceneController = sceneController;
        this.snotify = snotify;
        this.debug = Constants_1.Constants.debug_off;
        this.errorNotiCounter = 0;
        this.mini = true;
        this.loading = true;
        this.mainLink = '/' + global_1.AppRoutes.MAIN;
        this.ADMIN_USERS = this.mainLink + '/' + global_1.AppRoutes.ADMIN_USERS;
        this.searchCont = new forms_1.FormControl();
        this.subs = [];
        // show advanced settings?
        this.showAdvanced = false;
        // show more position info?
        this.showPositionAdvanced = false;
        // show/hide the quick config
        this.showConfig = false;
        // is there a new Team added lately?
        this.isNewTeams = false;
        this.uploadButtonDragHover = false;
        this.teamStats = null;
        this.isJapan = false;
        this.contactUsShow = false;
        this.contactUsState = 'ready';
        this.contactUsMessage = '';
        this.contactUsRequest = null;
        DEBUG_1.DEBUG.log('/app/main.component.ts');
        this.tasks = v2FileService.processingItems;
        this.openEdgeWarningDialog();
        // Check if mobile screen and adjust sidenav
        this.navOpened = !this.isMobile();
        this.navMode = this.isMobile() ? 'over' : 'side';
        this.fourD.onSocketCommand('*').subscribe(a => {
            if (this.debug) {
                console.log('Socket', a);
            }
        });
        this.fourD.onSocketCommand('ping').subscribe(a => {
            if (this.debug) {
                this.fourD.sendSocket('pong');
            }
        });
        this.fourD.onSocketCommand('credit_change').subscribe(a => {
            // console.log('credit', a)
            var account = this.fourD.teams.find(aa => aa.id == a.id);
            account.adhocCredit = a.adhocCredit;
            account.autoCredit = a.autoCredit;
        });
        // Subscribe to window resize event to change the nav mode
        rxjs_1.fromEvent(window, 'resize').subscribe(event => this.navMode = this.isMobile() ? 'over' : 'side');
        /* disabled, possibly remove
        // access control changes
        this.permissions.updatedAccess$.subscribe(tmp => {
          if ( this.debug ) { console.log ( 'main subscribed event access control' );}
          this.service.roleUpdate();
        });
        */
        // main service onReady; it all starts here: subscribing to service.onReady pulls down account and profile
        service.onReady().pipe(operators_1.flatMap(_ => v2FileService.init())).subscribe(s => {
            if (this.debug) {
                console.log('main.comp Service onReady', s);
            }
            // details about the account
            var accountMeta = this.service.objectMetas.find(o => o.uid == 'Account');
            if (this.debug) {
                console.log('Account meta', accountMeta);
            }
            // crude canAdd setting
            this.canAdd = !!accountMeta && !!accountMeta.acl.find(p => p == 'api_create');
            if (!fourD.teams.length) {
                this.noAccount = true;
                this.loading = false;
                return;
            }
            // active user
            var toLoad = fourD.teams[0].uid;
            if (this.fourD.activeUser && this.fourD.activeUser['lastAccount'] && this.fourD.teams.find(t => t.uid == this.fourD.activeUser['lastAccount'])) {
                toLoad = this.fourD.activeUser['lastAccount'];
            }
            // teams
            this.v2FileService.initTeam(this.fourD.teams.find(t => t.uid == toLoad))
                .subscribe(succ => {
                this.loading = false;
                let team = this.fourD.activeTeam;
                if (team) {
                    let hostname = team['hostname'] ? team['hostname'] : 'other';
                    this.isJapan = hostname.indexOf('link') !== -1 ? true : false;
                    // console.log('!!! hostname',team, hostname, this.isJapan );
                    if (this.debug) {
                        console.log("app.service :: onReady() Vasat ready");
                    }
                }
                this.fourD.getQuotas().subscribe(s => {
                    this.teamStats = s;
                });
                this.checkForNewTeams();
                // init all permissions for the current user
                // this.service.setupPermissions();
                // this.service.onRoleChange();
                this.updatePluginManager();
                loading_spinner_1.LoadingSpinner.end();
            }, err => {
                this.openSnackBarError('SIGNIN.ERROR.ACC_LOAD');
                this.loading = false;
                loading_spinner_1.LoadingSpinner.end();
            });
            // Messages
            var start, error, completed;
            this.translate.get(['TASK.START', 'TASK.ERROR', 'TASK.COMPLETE']).pipe(operators_1.map(params => {
                start = params['TASK.START'];
                error = params['TASK.ERROR'];
                completed = params['TASK.COMPLETE'];
            }), operators_1.mergeMap(e => {
                return fourD.runningTasksObservable;
            })).subscribe(t => {
                if (t.task.name == 'THUMB' || t.task.name == "JPG_DZI")
                    return;
                if (t.event == 'add') {
                    this.openSnackBarInfo(start, null, { task: t.task });
                }
                else if (t.finished == true && t.task.error) {
                    this.openSnackBarError(error, null, { task: t.task });
                }
                else if (t.finished == true && t.error) {
                    this.openSnackBarError(error, null, { task: t.task });
                }
                else if (t.finished) {
                    this.openSnackBarSuccess(completed, null, { task: t.task });
                }
            });
        }, e => {
            this.loading = false;
            this.error = e;
        });
        // not sure?
        this.searchFilesFolder();
        // upload events
        this.subs.push(this.mainService.uploadFilesSub.subscribe(e => {
            this.uploadFiles(e);
        }));
        // upload from dropbox
        this.subs.push(this.mainService.openDropBoxSub.subscribe(e => {
            this.uploadDropbox(e);
        }));
        // drop / upload events
        this.subs.push(this.mainService.dropFilesSub.subscribe(e => {
            this.dropFile(e);
        }));
        // upload existing files
        this.subs.push(this.mainService.uploadExistingFiles.subscribe(_ => {
            if (!this.isCurrentRouteProject() && this.isCurrentRouteProjectList()) {
                this.openUploadProjectDialog().subscribe(data => {
                    if (data) {
                        this.router.navigate(['projects', 'map', data.project.id], {
                            relativeTo: this.activatedRoute,
                            queryParams: {
                                sceneId: data.scene.id,
                                addExistingData: true
                            }
                        });
                    }
                });
            }
        }));
        this.mapService.onCesiumReady().subscribe(_ => {
            // check the location toggle, and show/hide the location entity
            setTimeout(() => {
                this.toggleLocation();
                // deal with some user settings
                this.onUserSettings();
            }, 1000);
        });
    }
    onReady() {
        // Check if we have setup param, meaning we are coming from the initial setup page
        this.activatedRoute.queryParams.subscribe(params => {
            if (params['setup']) {
                let dialogRef = this.dialog.open(setup_dialog_1.SetupDialog, {
                    width: '850px',
                    data: {},
                    panelClass: 'setup-bg',
                    disableClose: true
                });
                return dialogRef.afterClosed();
            }
        });
        // Listen to vasat errors. Specifically listening to invalid token errors so we can redirect user to the login page.
        rxjs_1.combineLatest([this.service.V.onErrorEvent, this.translate.get(["SIGNIN.SESSION_EXPIRE", "SIGNIN.SESSION_EXPIRE_TITLE"])]).subscribe(([error, text]) => {
            //console.log("ERROR occurred error ",error)
            // If token invalid redirect to login page
            // Special case error when "Bad User credentials" as it has same error code 403 as other errors. This needs to be changed in Vasat. for now we just work around it
            if ((error.status == 405 || error.status == 406) && this.errorNotiCounter == 0) {
                // Keep counter to show error only once even if ther are multiple errors thrown
                this.errorNotiCounter = this.errorNotiCounter + 1;
                this.service.V.invalidateSession();
                // Clear 4DM specific states
                this.fourD.clearStates();
                this.snotify.warning(text["SIGNIN.SESSION_EXPIRE"], text["SIGNIN.SESSION_EXPIRE_TITLE"], { timeout: 4000 }).on("destroyed", (toast) => {
                    this.errorNotiCounter = 0;
                });
                this.router.navigate(['auth']);
            }
        });
    }
    onError(e) {
        if (e.status == 406 || e.status == 405) {
            this.fourD.clearStates();
            this.router.navigate(['/auth']);
        }
    }
    updatePluginManager() {
        setTimeout(() => {
            this.pluginManager.pluginCategories = [plugins_1.FdmPlugin.category.generic];
            if (this.fourD && this.fourD.activeUser) {
                if (this.fourD.activeUser['showPluginsAdvanced']) {
                    this.pluginManager.pluginCategories.push(plugins_1.FdmPlugin.category.advanced);
                }
                if (this.fourD.activeUser['showPluginsTechnical']) {
                    this.pluginManager.pluginCategories.push(plugins_1.FdmPlugin.category.technical);
                }
                if (this.fourD.activeUser['showPluginsBeta']) {
                    this.pluginManager.pluginCategories.push(plugins_1.FdmPlugin.category.beta);
                }
                if (this.fourD.activeUser['showPluginsExperimental']) {
                    this.pluginManager.pluginCategories.push(plugins_1.FdmPlugin.category.experimental);
                }
                if (this.fourD.activeUser['showPluginsDebug']) {
                    this.pluginManager.pluginCategories.push(plugins_1.FdmPlugin.category.debug);
                }
                if (this.fourD.activeUser['showPluginsDeprecated']) {
                    this.pluginManager.pluginCategories.push(plugins_1.FdmPlugin.category.deprecated);
                }
            }
            this.pluginManager.clearCacheAllControllers();
        }, 50);
    }
    openURL(url) {
        window.open(url, '_blank');
    }
    // configure stuff when a user changes their settings
    onUserSettings() {
        await_class_1.XsAwait.until('mapService.viewer', this).then(_ => {
            let viewer = this.mapService.viewer;
            if (this.fourD && this.fourD.activeUser && viewer['scene']) {
                let a = this.fourD.activeUser;
                // should we show FPS?
                viewer['scene'].debugShowFramesPerSecond = a['showFPS'];
                // if no setting for showing coordinates, default is true
                if (!a.hasOwnProperty('showCoordinates')) {
                    this.fourD.activeUser['showCoordinates'] = true;
                }
                if (!a.hasOwnProperty('showCameraCoordinates')) {
                    this.fourD.activeUser['showCameraCoordinates'] = false;
                }
                if (!a.hasOwnProperty('showContextMenu')) {
                    this.fourD.activeUser['showContextMenu'] = false;
                }
                this.uiManager.sidebarHeightAdjust();
            }
        });
    }
    saveProfileDelayed() {
        setTimeout(() => {
            this.onUserSettings();
            this.uiManager.sidebarHeightAdjust();
            this.fourD.activeUser.saveObservable().subscribe(a => {
                var l = this.fourD.V.localSession();
                l.user = a;
                this.fourD.V.saveLocalSession(l);
            });
        }, 400);
    }
    toggleLocation() {
        setTimeout(() => {
            if (this.mapService.locationShape && this.fourD && this.fourD.activeUser) {
                this.mapService.locationShape.show = this.fourD.activeUser['showLocation'];
            }
        }, 400);
    }
    toggleCesiumDebugger() {
        //Add Cesium Inspector
        this.mapService.viewer.extend(Cesium.viewerCesiumInspectorMixin);
    }
    flyToLocation() {
        this.mapService.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(this.mapService.geolocation.longitude, this.mapService.geolocation.latitude, this.mapService.geolocation.height ? this.mapService.geolocation.height : (this.mapService.geolocation.sampledHeight ? this.mapService.geolocation.sampledHeight : this.mapService.geolocation.cameraHeight))
        });
    }
    augmentUserPermissions() {
        // the ACL permissions service is stashed away in the map.service, as it's included in most (if not all) other components
        // todo
    }
    togMini() {
        this.mini = !this.mini;
        setTimeout(() => this.reJig = true, 200);
        setTimeout(() => this.reJig = false, 400);
    }
    menuClicked(option) {
        if (option == 'explorer') {
            this.navigateToRoute(this.routes.MAIN_EXPLORER);
        }
        else if (option == 'inspector') {
            this.navigateToRoute(this.routes.MAIN_INSPECTOR);
        }
        else if (option == 'settings') {
            this.navigateToRoute(this.routes.MAIN_SETTINGS);
        }
        // Close the menu drawer
        if (this.isMobile())
            this.sidenav.toggle();
    }
    setActiveAccount(account) {
        this.v2FileService.initTeam(account).subscribe(succ => {
            if (succ) {
                this.fourD.activeUser['lastAccount'] = account.uid;
                this.fourD.activeUser.saveObservable().subscribe();
                this.navigateToRoute(this.routes.MAIN);
            }
        });
    }
    logout() {
        let me = this;
        this.translate.get(['GENERIC.OK', 'GENERIC.CANCEL', 'NAV.LOGOUT_MESSAGE', 'LOGOUT_ERROR']).pipe(operators_1.mergeMap(trans => {
            this.error = trans['NAV.LOGOUT_ERROR'];
            return this.openDialog(trans['NAV.LOGOUT_MESSAGE'], null, trans['GENERIC.OK'], trans['GENERIC.CANCEL']);
        }), operators_1.mergeMap(result => {
            if (result) {
                this.loading = true;
                // Go to root page on logout
                me.router.navigateByUrl(global_1.AppRoutes.AUTH);
                return this.service.V.logoutObservable();
            }
            else {
                return rxjs_1.empty();
            }
        })).subscribe(succ => {
            this.loading = false;
            this.fourD.clearStates();
        }, err => {
            this.loading = false;
            this.openSnackBarError(this.error);
        });
    }
    reconnect() {
        this.fourD.initSocket(this.fourD.V.localSession());
    }
    addAccount() {
        var inp = { value: '' };
        this.openDialog('SETTINGS.NEW_ACCOUNT', 'SETTINGS.NEW_DESC', null, null, inp).subscribe(res => {
            if (res && res.length) {
                var accountId = res.replace(' ', '').toLowerCase();
                var a = new _4d_mapper_1.Account(this.service.V);
                a.name = res;
                a.uid = accountId;
                this.service.V.api('/api/Account/' + this.service.fourD.activeTeam.id + '.makeNew', 'post', a.toJSON()).subscribe(s => {
                    this.openDialog('SETTINGS.ACCOUNT_MADE', 'SETTINGS.ACCOUNT_GOTO', 'GENERIC.YES').pipe(operators_1.concatMap(s => this.fourD.V.searchByObject(_4d_mapper_1.Account).queryObservable().pipe(operators_1.map(r => {
                        this.fourD.domain = r.items.find(a => a.isDomain);
                        this.fourD.rootAccounts = r.items.filter(a => !a.parent && a.uid != 'sample');
                        this.fourD.sampleAccount = r.items.find(a => a.uid == 'sample' && a.active);
                        this.fourD.teams = r.items.filter(a => a.uid != 'sample');
                        return s;
                    })))).subscribe(s => {
                        if (s) {
                            this.fourD.setActiveTeam(accountId).subscribe(s => this.router.navigate(['app', 'admin', 'account']));
                        }
                        else {
                        }
                    });
                }, e => this.openSnackBarError('No permission to create account ' + e));
            }
        });
    }
    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }
    searchFilesFolder() {
        this.searchCont.valueChanges.pipe(operators_1.debounceTime(1000)).subscribe(s => {
            this.mainService.searchFilesFolder.next(s);
        });
    }
    searchFilesFolderWithoutGlobal() {
        setTimeout(() => {
            this.mainService.searchFilesFolderWithoutGlobal.next();
        }, 1500);
    }
    toggleTeamFavourite() {
        if (!this.fourD.activeTeam.props.hasOwnProperty('isNew')) {
            this.fourD.activeTeam.props['isNew'] = false;
        }
        this.fourD.activeTeam.props['isNew'] = !this.fourD.activeTeam.props['isNew'];
        this.fourD.activeTeam.saveObservable().subscribe();
        this.checkForNewTeams();
    }
    checkForNewTeams() {
        // reset isNewTeams flag
        this.isNewTeams = false;
        // check if there are any new teams
        this.fourD.teams.forEach(t => {
            // console.log ( "!", t, )
            if (t.props['isNew']) {
                this.isNewTeams = true;
            }
        });
    }
    setTeam(a) {
        // console.log ( 'switching organization ...' );
        var u = this.fourD.V.localSession().user;
        u['lastAccount'] = a.uid;
        u.saveObservable().subscribe();
        this.loading = true;
        this.v2FileService.initTeam(a).subscribe(succ => {
            this.router.navigate(['/app']);
            this.loading = false;
            if (a.props['isNew']) {
                a.props['isNew'] = false;
            }
            a.saveObservable().subscribe();
            this.checkForNewTeams();
            // redo the permissions
            // this.service.setupPermissions();
            // this.service.onRoleChange();
        });
    }
    dragDropUploadButtonControl(e, entering) {
        this.uploadButtonDragHover = entering;
        e.preventDefault();
        e.stopPropagation();
    }
    helloDrop(e, entering) {
        this.mainService.isOver = entering;
    }
    dragOver(e) {
        e.preventDefault();
        this.mainService.isOver = true;
        return false;
    }
    openSharableDialog() {
        let dialogRef = this.dialog.open(sharable_component_1.SharableComponent, {
            panelClass: 'custom-dialog-container'
        });
        dialogRef.afterClosed().subscribe();
    }
    openUploadGlobalDialog() {
        let dialogRef = this.dialog.open(upload_global_component_1.UploadGlobalComponent, {
            panelClass: 'custom-dialog-container'
        });
        dialogRef.afterClosed().subscribe();
    }
    openUploadProjectDialog() {
        let dialogRef = this.dialog.open(upload_to_project_component_1.UploadToProjectComponent, {
            panelClass: 'custom-dialog-container'
        });
        return dialogRef.afterClosed();
    }
    dropFile(e) {
        if (e.stopPropagation)
            e.stopPropagation();
        e.preventDefault();
        if (!this.mainService.selectedFolder && !this.isCurrentRouteProjectList()) {
            this.openDialog('FILE_LIST.DIALOG.SELECT_FOLDER').subscribe();
            this.mainService.isOver = false;
            return;
        }
        else if (e.dataTransfer.files.length > 20) {
            this.openDialog('FILE_LIST.DIALOG.TOOMANY', 'FILE_LIST.DIALOG.TOOMANY_DESC').subscribe();
            return;
        }
        else if ((this.mainService.selectedFolder && this.mainService.selectedFolder.account != this.fourD.activeTeam) && !this.isCurrentRouteProjectList()) {
            this.openDialog('FILE_LIST.DIALOG.TEAM_WRONG').subscribe();
            this.mainService.isOver = false;
            return;
        }
        else {
            if (e.stopPropagation)
                e.stopPropagation();
            e.preventDefault();
            if (!this.isCurrentRouteProjectList() && this.mainService.dataType == 'Transform') {
                this.openSnackBarError('FILE_LIST.DIALOG.FILE_TYPE');
                return false;
            }
            var filez = e.dataTransfer.files;
            var l = filez.length;
            var grp = _.groupBy(filez, (obj, i) => '_' + Math.floor(i / 10));
            this.selectFolderAndDeque(grp);
            this.mainService.isOver = false;
            return false;
        }
    }
    uploadFiles(e) {
        console.log('##### main :: uploadFiles()', e);
        if (e.stopPropagation)
            e.stopPropagation();
        e.preventDefault();
        if (!this.mainService.selectedFolder && !this.isCurrentRouteProjectList()) {
            this.openDialog('FILE_LIST.DIALOG.SELECT_FOLDER').subscribe();
            return false;
        }
        else if (e.srcElement.files.length > 20) {
            this.openDialog('FILE_LIST.DIALOG.TOOMANY', 'FILE_LIST.DIALOG.TOOMANY_DESC').subscribe();
            return false;
        }
        else {
            if (!this.isCurrentRouteProjectList() && this.mainService.dataType == 'Transform') {
                this.openSnackBarError('FILE_LIST.DIALOG.FILE_TYPE');
                return false;
            }
            var filez = e.srcElement.files;
            var l = filez.length;
            var grp = _.groupBy(filez, (obj, i) => '_' + Math.floor(i / 10));
            this.selectFolderAndDeque(grp);
            return false;
        }
    }
    deQueue(grp, folder, scene, project) {
        var a = Object.keys(grp);
        if (a.length) {
            var key = a[0];
            var items = grp[key];
            this._sendBatch(items, folder, scene, project).subscribe(s => {
                delete grp[key];
                this.triggerDatasetUploading(scene, project);
                this.deQueue(grp, folder, scene, project);
            }, e => {
                if (e.status == 92021)
                    this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_DISK');
                else
                    this.openSnackBarError(e.message);
            });
        }
    }
    uploadDropbox(file) {
        var folder = null;
        if (this.isCurrentRouteProjectList()) {
            if (this.isCurrentRouteProject()) {
                folder = this.mapService.scene.folder;
            }
            else {
                this.openSnackBarError('FILE_LIST.NAV.DROPBOX_PROJECT');
            }
        }
        else {
            folder = this.mainService.selectedFolder['root'] ? null : this.mainService.selectedFolder;
        }
        if (folder)
            file['targetFolder'] = folder.id;
        this.fourD.V.api('/api/Account/' + this.fourD.activeTeam.id + '/dropbox', 'post', file)
            .subscribe(s => this.openSnackBarInfo('FILE_LIST.NAV.DROPBOX_DOWNLOAD'), e => this.openSnackBarError(e.message));
    }
    selectFolderAndDeque(grp) {
        let folder;
        if (this.isCurrentRouteProjectList()) {
            if (this.isCurrentRouteProject()) {
                this.dequeFromProject(folder, grp, this.mapService.currentProject, this.mapService.scene);
            }
            else {
                this.openUploadProjectDialog().subscribe(data => {
                    if (data) {
                        this.dequeFromProject(folder, grp, data.project, data.scene);
                    }
                });
            }
        }
        else {
            folder = this.mainService.selectedFolder['root'] ? null : this.mainService.selectedFolder;
            this.deQueue(grp, folder);
        }
    }
    dequeFromProject(folder, grp, project, scene) {
        if (scene.folder) { // if scene have folder then add to scene folder
            this.deQueue(grp, scene.folder, scene, project);
        }
        //else if (project.folder) { // if project has folder but scene dont then create scene folder and upload to scene folder
        //  this.createSceneFolderAndDeque(grp, scene, project);
        //} 
        else { // create project folder then create scene folder and upload to scene folder
            this.createSceneFolderAndDeque(grp, scene, project);
        }
    }
    triggerDatasetUploading(scene, project) {
        if (this.isCurrentRouteProjectList()) {
            if (!this.isCurrentRouteProject()) {
                this.router.navigate(['projects', 'map', project.id], {
                    relativeTo: this.activatedRoute,
                    queryParams: { sceneId: scene.id }
                });
            }
            this.mapService.datasetUploadingOrTilling.next();
        }
    }
    _sendBatch(files, folder, scene, project) {
        this.filesObs = files.map(v => {
            var name = v.name;
            if (scene) {
                var blank = new _4d_mapper_1.Dataset(this.service.V).set({
                    name: name,
                    folder: folder,
                    incomplete_offset: 0,
                    incomplete_seq: 0,
                    incomplete_total: length,
                    incomplete: true,
                    for_transform_group: scene.id,
                });
            }
            else {
                var blank = new _4d_mapper_1.Dataset(this.service.V).set({
                    name: name,
                    folder: folder,
                    incomplete_offset: 0,
                    incomplete_seq: 0,
                    incomplete_total: length,
                    incomplete: true
                });
            }
            return this.service.V.searchByObject(_4d_mapper_1.Dataset)
                .equals('folder', folder ? folder.id : null)
                .equals('name', name)
                .queryObservable().pipe(operators_1.flatMap(s => {
                if (s.items.length > 0 && !s.items[0].incomplete) {
                    return this.openDialogWithMeta({ file: v.name }, 'FILE_LIST.OVERRIDE.TITLE', 'FILE_LIST.OVERRIDE.MSG', 'GENERIC.YES', 'GENERIC.NO').pipe(operators_1.mergeMap(res => {
                        if (res)
                            return rxjs_1.of({
                                dataset: s.items[0],
                                file: v,
                                valid: true
                            });
                        else
                            return rxjs_1.of({ valid: false });
                    }));
                }
                else if (s.items.length > 0 && s.items[0].incomplete) {
                    return rxjs_1.of({
                        dataset: s.items[0],
                        file: v,
                        valid: true
                    });
                }
                else {
                    return blank.saveObservable().pipe(operators_1.map(ds => {
                        return {
                            dataset: ds,
                            file: v,
                            valid: true
                        };
                    }));
                }
            }));
        });
        return index_1.forkJoin(this.filesObs).pipe(operators_1.map(res => {
            res.forEach(s => {
                if (s.valid) {
                    if (scene && this.isCurrentRouteProjectList() && this.mapService.datasetForLayers.findIndex(dl => dl.id === s.dataset.id) === -1) {
                        // this.incomingData.add(s.dataset); // refactoring the below line
                        this.mapService.datasetForLayers.push(s.dataset);
                    }
                    try {
                        // add the upload to the list of files (unless its an override of existing file)
                        if (this.filesObs.length < 10 && !this.isCurrentRouteProjectList() && this.mainService.fileListComponent) {
                            // inject is not working from angular 8
                            // this.mainService.fileListComponent.dataSource.injectVals([s.dataset])
                            this.mainService.fileListComponent.refresh();
                        }
                    }
                    catch (e) {
                        console.error(e);
                    }
                    this.processObjFile(s.dataset, s.file);
                    this.fourD.uploadFile(s.dataset, s.file, 'data', 19000000).error = (e) => {
                        if (e.status == 92021)
                            this.openDialog('PLAN.QUOTA', 'PLAN.QUOTA_DESC_DISK');
                        else
                            this.openSnackBarError(e.message);
                    };
                }
            });
            return res;
        }));
    }
    isCurrentRouteProjectList() {
        return this.router.url.indexOf('app/projects') !== -1;
    }
    isCurrentRouteProject() {
        return this.router.url.indexOf('app/projects/map') !== -1 && this.mapService.currentProject;
    }
    processObjFile(dataset, file) {
        if (!file || !file.name.endsWith('.obj'))
            return;
        var blob = file.slice(0, 1024);
        var reader = new FileReader();
        reader.readAsText(blob);
        reader.onload = (data) => {
            let csvData = reader.result;
            var a = csvData.split('\n');
            if (a.length > 3 && a[a.length - 2]) {
                // read mtlfilename from header and save it to the dataset
                for (let i = 0; i < a.length; i++) {
                    if (a[i].indexOf('mtllib') !== -1) {
                        let mtlFileArray = a[i].split(' ');
                        mtlFileArray.splice(0, 1);
                        let mtlFileName = mtlFileArray.join(' ');
                        dataset['mtlFileName'] = mtlFileName.trim();
                        break;
                    }
                }
                // read the x,y,z from the header and save it in the dataset
                a = a[a.length - 2].split(' ');
                if (a.length >= 4) {
                    dataset['objFileXYZ'] = {
                        x: a[1],
                        y: a[2],
                        z: a[3]
                    };
                    dataset.saveObservable().subscribe();
                }
            }
        };
        reader.onerror = () => {
            this.snackBar.open('GENERIC.READ_ERROR', 'GENERIC.ERROR', { duration: Constants_1.Constants.SNACKBAR_DURATION });
        };
    }
    createProjectFolderAndDeque(grp, scene, project) {
        this.createSceneFolderAndDeque(grp, scene, project);
    }
    createSceneFolderAndDeque(grp, scene, project) {
        // not creating folders anymore, jsut fetching ones server should have auto made.
        // (Note this wont help existing scenes, but could put a one of server code that generates folders for existing scenese if needed)
        scene.sceneFolder.subscribe(f => this.deQueue(grp, f, scene, project));
    }
    gotoContactUs() {
    }
    clickContactUs() {
        this.contactUsRequest = {
            subject: '',
            priority: 'normal',
            category: 'question',
            body: ''
        };
        this.contactUsShow = true;
    }
    clickContactUsSend() {
        this.contactUsState = 'sending';
        const lf = '\n';
        this.contactUsRequest.body = `${lf}${this.contactUsMessage} ${lf}`;
        // send support tickets through ZenDesk
        this.service.sendSupportTicket(this.contactUsRequest).subscribe(res => {
            this.contactUsState = 'sent';
            //console.log('!! email OK', request, res );
        }, e => {
            this.contactUsState = 'error';
            //console.log('!! email ERROR', request, e );
        });
    }
    clickContactUsDone() {
        this.contactUsShow = false;
        this.contactUsState = 'ready';
    }
    autoFill(name) {
        if (this.fourD) {
            switch (name) {
                case 'NAME':
                    if (this.fourD.activeUser) {
                        return this.fourD.activeUser.name;
                    }
                    break;
                case 'EMAIL':
                    if (this.fourD.activeUser) {
                        return this.fourD.activeUser.email;
                    }
                    break;
                case 'USER_ID':
                    if (this.fourD.activeUser) {
                        return this.fourD.activeUser.id;
                    }
                    break;
                case 'ACCOUNT_ID':
                    if (this.fourD.activeTeam) {
                        return this.fourD.activeTeam.id;
                    }
                    break;
            }
        }
        return '';
    }
    showQuickGuides() {
        // Use the router URL to figure what screen we are on, so we open the correct quick guides
        var screen = "";
        if (this.router.url.includes("/app/projects/map")) {
            // Map screen
            screen = "map";
            // Dasboard screen
        }
        else if (this.router.url.includes("/app/projects")) {
            screen = "dashboard";
            // Data explorer screen
        }
        else if (this.router.url.includes("/app/explorer")) {
            screen = "explorer";
            // User management screen
        }
        else if (this.router.url.includes("/app/admin/users")) {
            screen = "users";
            // Account screen
        }
        else if (this.router.url.includes("/app/admin/account")) {
            screen = "account";
            // Plans and credit screen
        }
        else if (this.router.url.includes("/app/admin/plan")) {
            screen = "plan";
        }
        this.uiManager.toggleQuickGuidePopup(screen, true);
    }
}
exports.MainComponent = MainComponent;
